import * as d3 from 'd3'
export default {
  methods: {

    draw_ExcelForm(selection, dataSet) {
      this.CRT.id++
      this.CRT.count++

      let itemGroup = selection
      .append('g')
      .attr('id', `LIST_${this.CRT.id}`)
      .attr('transform', `translate(0, ${this.CRT.count * 80})`)

      itemGroup
      .append('rect')
      .attr('id', `IFRAME_${this.CRT.id}`)
      .attr('x', 40).attr('y', 0).attr('rx', 5).attr('ry', 5).attr('width', 840).attr('height', 60)
      .attr('fill', '#fff').attr('stroke', '#E0E0DF').attr('stroke-width', .5).attr('fill-opacity', .1)

      itemGroup
      .append('image')
      .attr('xlink:href', this.HOST + `/Database/icon/Del.svg`)
      .attr('x', 20).attr('y', 21).attr('width', 13).attr('cursor', 'pointer')
      .on('mouseover', function() { d3.select(this).transition().duration(75).style('opacity', .5)} )
      .on('mouseout', function() { d3.select(this).transition().duration(250).style('opacity', 1)} )
      .on('click', ()=> { 
        this.del_Data(dataSet.SEQ) // -----> below
      })

      itemGroup
      .append('image')
      .attr('xlink:href', this.HOST + `/Database/icon/DB_Excel.svg`).attr('x', 85).attr('y', 25).attr('height', 17)

      let input = [
        {id: `TYPE_${this.CRT.id}`,        label: 'Type',       x: 55,  y: 120, width: 50,  maxLen: 15, value: dataSet.TYPE, visible: 'Y',},
        {id: `SEQ_${this.CRT.id}`,         label: 'SN',         x: 55,  y: 20, width: 20,  maxLen: 1, value: dataSet.SEQ,},
        {id: `FILE_PATH_${this.CRT.id}`,   label: 'File Path',  x: 105, y: 20, width: 480, maxLen: 100},
        {id: `NAME_${this.CRT.id}`,        label: 'File Name',  x: 590, y: 20, width: 135, maxLen: 18},
        {id: `EXCEL_SHEET_${this.CRT.id}`, label: 'Sheet Name', x: 730, y: 20, width: 135, maxLen: 18},
      ]
      input.forEach(d=> { this.data_InputBox(itemGroup, d) })

      // Verify Coloring
      d3.select(`#IFRAME_${this.CRT.id}`).attr('fill', (dataSet.FILE_PATH && dataSet.EXCEL_SHEET && dataSet.NAME) ? '#B4E3FA' : '#fff')

      this.reflash(this.CRT) // #####
    },



    draw_TableForm(selection, dataSet) {

      this.CRT.id++
      this.CRT.count++

      let itemGroup = selection
      .append('g')
      .attr('id', `LIST_${this.CRT.id}`)
      .attr('transform', `translate(0, ${this.CRT.count * 80})`)

      itemGroup
      .append('rect')
      .attr('id', `IFRAME_${this.CRT.id}`)
      .attr('x', 40).attr('y', 0).attr('rx', 5).attr('ry', 5)
      .attr('width', 840).attr('height', 60)
      .attr('fill', '#fff').attr('stroke', '#E0E0DF').attr('stroke-width', .5).attr('fill-opacity', .1)

      itemGroup
      .append('image')
      .attr('xlink:href', this.HOST + `/Database/icon/Del.svg`).attr('x', 20).attr('y', 21).attr('width', 13)
      .attr('cursor', 'pointer')
      .on('mouseover', function() { d3.select(this).transition().duration(75).style('opacity', .5)} )
      .on('mouseout', function() { d3.select(this).transition().duration(250).style('opacity', 1)} )
      .on('click', ()=> { 
        this.del_Data(dataSet.SEQ) // -----> below
       })

      this.data_Dropdown(itemGroup, this.dataType.filter(f=> f !== 'Excel'), {id: `TYPE_${this.CRT.id}`, label: 'Data Type', boxWidth: 100, x: 85, y: 20, icon: `TYPE_${this.CRT.id}`})
      this.data_Dropdown(itemGroup, this.database, {id: `DATABASE_${this.CRT.id}`, label: 'Database',  boxWidth: 150, x: 200, y: 20})
      d3.select(`#FORM_TYPE_${this.CRT.id}`).text(dataSet.TYPE)
      d3.select(`#ICON_TYPE_${this.CRT.id}`).attr('xlink:href', this.HOST + `/Database/icon/DB_${dataSet.TYPE}.svg`)

      let input = [
        {id: `SEQ_${this.CRT.id}`,    label: 'SN',          x: 55,  y: 20,  width: 20, maxLen: 1, value: dataSet.SEQ,},
        {id: `SCHEMA_${this.CRT.id}`, label: 'Schema Name', x: 365, y: 20, width: 180, maxLen: 18},
        {id: `NAME_${this.CRT.id}`,   label: 'Table Name',  x: 560, y: 20, width: 305, maxLen: 35},
      ]
      input.forEach(d=> { this.data_InputBox(itemGroup, d) })

      for(let i=this.CRT.id; i>=0; i--){
        if(d3.select(`#LIST_${i}`)) d3.select(`#LIST_${i}`).moveToFront()
      }

      // Verify Coloring
      d3.select(`#IFRAME_${this.CRT.id}`).attr('fill', (dataSet.TYPE && dataSet.DATABASE && dataSet.SCHEMA && dataSet.NAME) ? '#B4E3FA' : '#fff')

      this.reflash(this.CRT) // #####
    },


    del_Data(seq) {
      d3.select(`#LIST_${seq}`).remove()

      for(let i=seq+1; i<=this.CRT.id; i++) {
        let item = d3.select(`#LIST_${i}`)
        if(!item.empty()) {
          let y = this.getNode(`#LIST_${i}`, 'y')
          item.transition().duration(300).attr('transform', `translate(0, ${y - 80 - (381)})`)
        }
      }
      this.CRT.count--
      this.reflash(this.CRT) // #####
    },
    

    

    save_DataList(newDataSet, stg, target) {

      console.log(newDataSet) // -----<
      let filterData = this.rawData.filter(f=> !(f.STG_IDX == stg.IDX && f.RELATION == target))
      this.rawData = [...filterData, ...newDataSet]

      let data = this.rawData.filter(f=> f.STG_IDX == stg.IDX)

      this.close_Window()

      switch(target) {
        case 'Input':
          d3.select(`#INPUT_LIST_${stg.IDX}`).remove()
          this.child_InputList(stg, data.filter(f=> f.RELATION == 'Input'))
        break

        case 'Exec':
          d3.select(`#EXECUTION_LIST_${stg.IDX}`).remove()
          this.child_ExecList(stg, data.filter(f=> f.RELATION == 'Exec'))
        break

        case 'Output':
          d3.select(`#OUTPUT_LIST_${stg.IDX}`).remove()
          this.child_OutputList(stg, data.filter(f=> f.RELATION == 'Output'))
        break
      }

    },

    

  }
}